"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _TagDate = _interopRequireDefault(require("@rsuite/icon-font/lib/application/TagDate"));

// Generated by script, don't edit it please.
var TagDate = (0, _createSvgIcon["default"])({
  as: _TagDate["default"],
  ariaLabel: 'tag date',
  category: 'application',
  displayName: 'TagDate'
});
var _default = TagDate;
exports["default"] = _default;
module.exports = exports.default;